<template>
<!-- eslint-disable max-len -->
<div style="display: flex; flex-flow: row nowrap; justify-content: center; align-items: center; font-size: 120%;">
  <div>Downloading Report...</div>
</div>
</template>

<script>
export default {
  props: {
    blobUrl: { type: String },
    reportFileName: { type: String },
  },
  computed: {
  },
  methods: {
  },
  mounted() {
    let fileLink;
    if (this.blobUrl) {
      // create bogus <a> hyperlink element
      fileLink = window.document.createElement('a');
      // generate bloburl target
      fileLink.href = this.blobUrl;
      // force the name of the downloaded file
      fileLink.download = `${this.reportFileName || 'report'}.pdf`;
    }
    // sets up closing if the blob viewer doesn't open
    window.setTimeout(() => {
      if (!(window.location.href.startsWith('blob:'))) {
        window.close();
      }
    }, 300);
    if (fileLink) {
      // artificially triggers the click event
      fileLink.click();
    }
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/game/pages/PlayerReportDownloader.vue